<div class="page-wrapper">
  <metric></metric>
</div>
